module.exports = {
    "title": "Maintenance",
    "entityName": "maintenance",
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "id",
        "descending": true
    },
    "fields": [
        {
            "value": "service",
            "text": "Service",
            "type": "list",
            "table": {
                "sortable": true,
                "filter": true
            },
            list: ['SafetyDB', 'eCDS', 'eTMFlex', 'REDCap - Demo'],
        },

        {
            
            "value": "protocol_id",
            "text": "Protocol",
            title: "name",
            "type": "autocomplete",
            filter: (item, search) => { 
                
                let searchObj = { 'protocol.provider': 'REDCap', 'protocol.status' : '!=Draft'}

                if(search) {
                    searchObj['protocol.name'] = `%${search}%`
                }

                if(item.service == 'REDCap - Demo') {
                    searchObj['protocol.sponsor_id'] = 1
                }

                return searchObj
            },
            render: item => `${item.protocol.name}`,
            deps:['service'],
            visible: (search) => {
                return ['REDCap - Demo'].includes(search.service)
            }
        },

        {
            full:true,
            "value": "title",
            "text": "Title",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required",
            ]
        },

        {
            full:true,
            "value": "message",
            "text": "Message",
            "type": "component",
            "name": "app-rich-text-field",
            // "table": {
            //     "sortable": true,
            //     "filter": true
            // },
            "validators": [
                // "required",
            ]
        },

        {
            "value": "validFrom",
            "text": "Valid From",
            "type": "datetime",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required",
            ]
        },

        {
            "value": "validUntil",
            "text": "Valid Until",
            "type": "datetime",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required",
            ]
        },

        {
            "value": "allowLogin",
            "text": "Login Allowed",
            "type": "check",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                // "required",
            ]
        },


        {
            "value": "status",
            "text": "Status",
            "type": "list",
            "list": ['Enabled', 'Disabled'],
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                // "required",
            ]
        },
       

    ],
    "actions": [
         "upsert", "remove", "audit_trail"
    ]
}